<template>
  <v-container v-if="userIsAdmin()">
    <v-row>
      <v-col cols="12" sm="6">
        <h1>Configurar valores de inicio</h1>
      </v-col>
      <v-col cols="12" sm="6">
        <p class="clarification-message">
          Los valores que indiques a continuación representan los últimos
          valores registrados. <br />Si es necesario inicializar un contador
          indica 0 para que el próximo valor sea 1.
        </p>
      </v-col>
    </v-row>
    <v-form @submit.prevent="submitForm" class="mt-4">
      <v-container>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-for="(input, index) in inputs"
            :key="index"
          >
            <v-text-field
              v-model="input.value"
              :label="input.label"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn type="submit" color="primary" :loading="loading">
              Enviar
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-snackbar v-model="snackbar" :timeout="3000" color="success">
      {{ successMessage }}
      <template #action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script setup>
import { onMounted, ref } from 'vue'
// import { useVariablesStore } from '@/stores/variablesStore'
import { getEnvVariable, userIsAdmin } from '@/utils/helpers'
import {
  SELECT_COBROS,
  SELECT_PAGOS,
  SELECT_ENTRADAS
} from '@/utils/constants.js'
import { useVariablesStore } from '@/stores/variablesStore'

const loading = ref(false)
const variablesStore = useVariablesStore()
const inputs = ref([])
const successMessage = ref('')
const snackbar = ref(false)

const getVariables = () => {
  const newArray = []
  // Construir labels y names para SELECT_COBROS
  SELECT_COBROS.forEach((item) => {
    newArray.push({
      label: `(${item.type}) ${item.text}`,
      name: `${getEnvVariable('VUE_APP_REGISTRO_COBRO', 'registro_cobro')}_${item.value}`,
      value: 0, // Puedes ajustar esto según lo que necesites
      type: item.type
    })
  })

  // Construir labels y names para SELECT_PAGOS
  SELECT_PAGOS.forEach((item) => {
    newArray.push({
      label: `(${item.type}) ${item.text}`,
      name: `${getEnvVariable('VUE_APP_REGISTRO_PAGO', 'registro_pago')}_${item.value}`,
      value: 0, // Puedes ajustar esto según lo que necesites
      type: item.type
    })
  })
  // Construir labels y names para SELECT_BUZON
  newArray.push({
    label: `(G) Buzones`,
    name: getEnvVariable('VUE_APP_REGISTRO_BUZON', 'registro_buzon'),
    value: 0, // Puedes ajustar esto según lo que necesites
    type: 'G'
  })

  // Construir labels y names para SELECT_ENTRADAS
  SELECT_ENTRADAS.forEach((item) => {
    newArray.push({
      label: `(A) ${item.text}`,
      name: getEnvVariable('VUE_APP_NUMERO_FACTURA', 'numero_factura'),
      value: 0, // Puedes ajustar esto según lo que necesites
      type: 'A'
    })
  })
  // Ordenar el array por la propiedad type
  newArray.sort((a, b) => {
    if (a.type < b.type) return -1
    if (a.type > b.type) return 1
    return 0
  })
  return newArray
}
console.log(variablesStore)

onMounted(async () => {
  const newArray = []
  for (let variable of getVariables()) {
    console.log('get:', variable.key, variable)
    let result = await variablesStore.getValorVariable(variable.name, 0)
    if (result) {
      variable.value = parseInt(result)
    }
    newArray.push(variable)
  }
  inputs.value = newArray
})

const submitForm = async () => {
  loading.value = true
  successMessage.value = ''
  try {
    const variables = inputs.value.map((input) => {
      return { name: input.name, value: input.value }
    })
    console.log('Variables submit', variables)
    for (let variable of variables) {
      await variablesStore.setValorVariable(variable.name, variable.value)
    }
    successMessage.value = 'Variables enviadas correctamente!'
    snackbar.value = true
  } catch (error) {
    console.error('Error al enviar el formulario:', error)
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
/* Estilos opcionales para el formulario */
.success-message {
  color: green;
  margin-top: 10px;
}

.clarification-message {
  color: #888; /* Color del texto menos destacado */
  margin-top: 10px; /* Espaciado superior */
  font-size: 14px; /* Tamaño de fuente */
}
</style>
